import { render, staticRenderFns } from "./articulo.vue?vue&type=template&id=b47b6cc4&scoped=true&"
import script from "./articulo.vue?vue&type=script&lang=ts&"
export * from "./articulo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47b6cc4",
  null
  
)

export default component.exports